export { DeferLoadDirective } from './defer-load.directive';
export { BackgroundImageDirective } from './background-image.directive';
